import { useQuery } from '@tanstack/react-query'

import { useTRPC } from '@langmail/shared-ui'

/**
 * Returns the user's connected Gmail accounts plus the derived primary
 * (oldest by `created_at`). Data flows via `trpc.accounts.list` so the server
 * is the source of truth and `credentials` are never sent to the client.
 */
export const useAccounts = () => {
  const trpc = useTRPC()
  const query = useQuery(trpc.accounts.list.queryOptions())

  const accounts = query.data?.accounts ?? []
  const primaryAccountId = query.data?.primaryAccountId ?? null
  const primaryAccount = accounts.find((account) => account.id === primaryAccountId) ?? null

  return {
    ...query,
    accounts,
    primaryAccount,
    primaryAccountId,
  }
}
